// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"b2f0d0590220756c61fd","186":"8e676e83f6d19ff26792","554":"44e853a6e77f77a1610e","812":"fcdfb536e2e083fe1dd2"}[chunkId] + ".chunk.js";
};